<template>
  <div class="layout" :class="classObject" v-resize>
    <navbar></navbar>
    <sidebar></sidebar>
    <div class="content-wrap" id="content-wrap">
      <main id="content" class="content" role="main">
        <vuestic-pre-loader v-show="isLoading" ref="preLoader" class="pre-loader"></vuestic-pre-loader>
        <vuestic-widget class="no-padding no-v-padding no-v-margin">
          <div class="main row">
            <div class="col-md-12">
              <div class="col-md-6 offset-md-6 text-right">
                <button type="button" class="close" style="width:40px; height:40px;" @click="goBack">
                  <h1 style="margin-bottom:0px;">&times;</h1>
                </button>
              </div>
            </div>
          </div>
        </vuestic-widget>
        <router-view v-show="!isLoading"></router-view>
      </main>
    </div>
    <div class="made-by-footer">
      &copy;2018&ndash;{{currentYear}}. All rights reserved by&nbsp;<a :href="companyUrl" target="_blank">{{companyName}} </a>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  import Navbar from './navbar/Navbar'
  import Sidebar from './sidebar/Sidebar'
  import Resize from 'directives/ResizeHandler'

  import AutomationTab from './automation-tab/Automation.vue'
  import ResourceTab from './resource-tab/Resource.vue'
  import CollaborationTab from './collaboration-tab/Collaboration.vue'

  import ThemeService from '../../services/ThemeService'


  export default {
    name: 'other-layout',

    components: {
      Navbar,
      Sidebar,
      ResourceTab,
      AutomationTab,
      CollaborationTab
    },
    data: function () {
      return {
        flow: localStorage.getItem('flow-token'),
        currentTheme: 'fractel'
      }
    },
    directives: {
      resize: Resize
    },
    props: {
      fixed: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      ...mapGetters([
        'sidebarOpened',
        'toggleWithoutAnimation',
        'isLoading'
      ]),
      classObject: function () {
        return {
          'layout-fixed': this.fixed,
          'sidebar-hidden': !this.toggleWithoutAnimation && !this.sidebarOpened,
          'sidebar-hidden sidebar-hidden_without-animation': this.toggleWithoutAnimation && !this.sidebarOpened
        }
      },
      breadcrumbs () {
        return this.$store.getters.breadcrumbs(this.$route.name)
      },
      currentYear () {
        var now = new Date()
        return now.getFullYear()
      },
      logoClass () {
        return `${this.currentTheme}-logo`
      },
      companyName () {
        return this.currentTheme === 'fonestorm' ? ThemeService.themes.fonestorm.company : ThemeService.themes.fractel.company
      },
      companyUrl () {
        return this.currentTheme === 'fonestorm' ? ThemeService.themes.fonestorm.companyUrl : ThemeService.themes.fractel.companyUrl
      }
    },
    mounted () {
      this.currentTheme = ThemeService.currentTheme
      // Listen for theme changes
      this.$root.$on('theme-changed', this.updateTheme)
    },
    beforeDestroy () {
      this.$root.$off('theme-changed', this.updateTheme)
    },
    methods: {
      goBack () {
        this.$router.push({ name: this.$route.meta.parent || 'Home' })
      },
      updateTheme () {
        this.currentTheme = ThemeService.currentTheme
      }
    }
  }
</script>

<style lang="scss">
  @import "../../sass/_variables.scss";
  @import "~bootstrap/scss/mixins/breakpoints";
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";

  .layout {
    &-fixed {
      .content-wrap {
        padding-right: $layout-padding-right;
        padding-top: $sidebar-top;

        @include media-breakpoint-down(md) {
          padding: $content-mobile-wrap-fixed-layout;
          margin-left: 0;

        }
      }
    }
  }

  .content-wrap {
    margin-left: $content-wrap-ml;
    transition: margin-left 0.3s ease;
    padding-right: 0;
    padding-top: 0;

    padding-bottom: 0;

    .pre-loader {
      position: absolute;
      left: $vuestic-preloader-left;
      top: $vuestic-preloader-top;
    }

    .sidebar-hidden & {
      margin-left: 0;
    }

    @include media-breakpoint-down(md) {
      padding: $content-mobile-wrap;
      margin-left: 0;

      .sidebar-hidden & {
        margin-left: 0;
        padding-top: $content-mobile-wrap-sb-top;
      }
    }
  }

  .made-by-footer {
    position: absolute;
    padding-bottom: $made-by-footer-pb;
    height: $widget-mb;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .main {
    margin: 0;
    height: 100%;
  }

  .no-v-margin {
    margin-bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/OtherLayout.vue